// extracted by mini-css-extract-plugin
export default {"noContent":"no-content_noContent__8OHS3"};